function HelloWithProps(props){
    return <h1>Witaj, {props.name}!</h1>;
}

export default HelloWithProps;